import { Box, useBoolean } from "@chakra-ui/react";
import {
  CampaignImpressionsByLocationRO,
  CampaignTopicsByLocationRO,
} from "@intentsify/dto";
import { Card, IconButton, Loader } from "components";
import { DisplayPerformanceErrorBoundary } from "../../../../DisplayPerformanceErrorBoundary";
import { Suspense } from "react";
import { RiEarthLine } from "react-icons/ri";
import { DisplayPerformanceFilters } from "../../../../types";
import { ImpressionsAndTopicsMap } from "shared/components";

type MediaDeliveryMapProps = {
  campaignId: string | number;
  filters: DisplayPerformanceFilters;
  getImpressionsByLocation: (
    id: string | number,
    filters: DisplayPerformanceFilters
  ) => Promise<CampaignImpressionsByLocationRO>;
  getTopicsByLocation: (
    id: string | number,
    filters: DisplayPerformanceFilters
  ) => Promise<CampaignTopicsByLocationRO>;
};

const TITLE = "Media Delivery & Intent Topic Signal by Location";

const MediaDeliveryMap = (props: MediaDeliveryMapProps) => (
  <DisplayPerformanceErrorBoundary cardTitle={TITLE}>
    <MediaDeliveryMapContent {...props} />
  </DisplayPerformanceErrorBoundary>
);

const MediaDeliveryMapContent = ({
  campaignId,
  filters,
  getImpressionsByLocation,
  getTopicsByLocation,
}: MediaDeliveryMapProps) => {
  const [isGlobe, setIsGlobe] = useBoolean();

  return (
    <Card
      title={TITLE}
      actions={
        <IconButton
          size="xs"
          isActive={isGlobe}
          icon={<RiEarthLine />}
          tooltip={`Show ${isGlobe ? "map" : "globe"}`}
          onClick={setIsGlobe.toggle}
        />
      }
      ignoreTitleMargin
    >
      <Box w="100%" h="440">
        <Suspense fallback={<Loader minHeight="100%" />}>
          <ImpressionsAndTopicsMap
            id={campaignId}
            isGlobe={isGlobe}
            filters={filters}
            getImpressionsByLocation={getImpressionsByLocation}
            getTopicsByLocation={getTopicsByLocation}
            height={400}
          />
        </Suspense>
      </Box>
    </Card>
  );
};

export { MediaDeliveryMap };
